import UsersPage from '../components/UsersPage';

export default function DriversPage() {
  return (
    <UsersPage
      title="Drivers"
      subtitle="Approve verifications and manage driver accounts."
      userType="driver"
    />
  );
}
